import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './references.state';
import getters from './references.getters';
import actions from './references.actions';
import mutations from './references.mutations';

BaseStore.registerModule('references', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('references');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};